import { withIndexAndType } from "../../../core/helpers/date-util.js";
import AbstractPeriodTemplate from "./AbstractPeriodTemplate.js";

/**
 * A fixed period template computes a period with an periodIndex amount of periodType
 * from begining of the context year of its creation.
 *
 * For instance, a FixedPeriodTemplate of type "Quarter" and period index 1 would
 * be the first quarter of the current date year. e.g., Quarter 1 2017 if the context date was
 * Quarter 3 2017.
 *
 * periodType can be "Month" or "Quarter", and index can be any positive or negative value
 * (switching to a different year if needed : e.g., -12 months for September 2020 becomes
 * January 2019).
 *
 * @param {string} [spec.periodType] - Type of the resulting period (Month or Quarter).
 * @param {integer} [spec.periodIndex] - Index of the resulting period (any integer).
 */
export default class FixedPeriodTemplate extends AbstractPeriodTemplate {
	constructor({ periodType = "Month", periodIndex = 0 } = {}) {
		super({ periodType, ...arguments });
		this._periodIndex = periodIndex;
	}

	setPeriodType(periodType) {
		super.setPeriodType(periodType);
		this._periodIndex = 0;
	}

	getPeriodIndex() {
		return this._periodIndex;
	}

	setPeriodIndex(periodIndex) {
		this._periodIndex = periodIndex;
	}

	accept(visitor) {
		return visitor.visitFixedPeriodTemplate(this);
	}

	getPeriodForContext(context) {
		const contextPeriod = context.getPeriod();
		const resultDate = withIndexAndType({
			date: contextPeriod.getStart(),
			index: this._periodIndex,
			periodType: this._periodType,
		});

		return this._makePeriod({
			date: resultDate,
			periodType: this._periodType,
			context,
		});
	}

	isFixedPeriodTemplate() {
		return true;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.periodIndex = this._periodIndex;

		return properties;
	}

	static getType() {
		return "FixedPeriodTemplate";
	}
}
